import {
	ADMINADDRISKRULELIST_SUCCESS,
	ADMINADDRISKRULELIST_FAILED,
	RESET_ADMINADDRISKRULELIST,
	LOADING_ADMINADDRISKRULELIST,
	NETWORK_ERROR_ADMINADDRISKRULELIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetadminAddRiskRule = () => {
	return { type: RESET_ADMINADDRISKRULELIST };
};

const adminAddRiskRule = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINADDRISKRULELIST });
	await adminServices
		.post("addOrUpdateRiskRule", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminAddRiskRulesuccess(res.data));
					break;
				default:
					dispatch(adminAddRiskRuleFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINADDRISKRULELIST,
				payload: err
			});
		});
};
function adminAddRiskRulesuccess(data) {
	return {
		type: ADMINADDRISKRULELIST_SUCCESS,
		payload: data
	};
}
function adminAddRiskRuleFailed(data) {
	return {
		type: ADMINADDRISKRULELIST_FAILED,
		payload: data
	};
}

export { resetadminAddRiskRule, adminAddRiskRule };
